export default {
  // count audience online, offline in a presentation
  ONLINE_COUNT_CHANGED: 'user-online-count',
  // handle data q&a on presentation
  QUESTIONS_CHANGED: 'question-and-answer',
  PRESENTATION: 'presentation',
}
